import { useState, useEffect } from 'react'

interface EditTimeCountdownProps {
  createdAt: string
  className?: string
}

export default function EditTimeCountdown({ createdAt, className = '' }: EditTimeCountdownProps) {
  const [timeLeft, setTimeLeft] = useState<string>('')
  const [isExpired, setIsExpired] = useState(false)

  useEffect(() => {
    const updateCountdown = () => {
      const createdTime = new Date(createdAt).getTime()
      const now = new Date().getTime()
      const thirtyMinutesInMs = 30 * 60 * 1000
      const expiryTime = createdTime + thirtyMinutesInMs
      const remaining = expiryTime - now

      if (remaining <= 0) {
        setTimeLeft('')
        setIsExpired(true)
        return
      }

      setIsExpired(false)

      // Convert to minutes and seconds
      const minutes = Math.floor(remaining / (1000 * 60))
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000)

      if (minutes > 0) {
        setTimeLeft(`${minutes}m left`)
      } else {
        setTimeLeft(`${seconds}s left`)
      }
    }

    // Update immediately
    updateCountdown()

    // Update every second
    const interval = setInterval(updateCountdown, 1000)

    return () => clearInterval(interval)
  }, [createdAt])

  if (isExpired || !timeLeft) {
    return null
  }

  return (
    <span className={`text-xs text-gray-400 ${className}`}>
      ({timeLeft})
    </span>
  )
}
